import { useTranslation } from "react-i18next";
import { Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";


interface CommissionDetailsProps {
  percentage: number | null;
  source: "stored" | "derived" | "unavailable";
}

const formatPercentage = (value: number) => `${value.toFixed(2).replace(/\.00$/, "")}%`;

export const CommissionDetails = ({
  percentage,
  source,
}: CommissionDetailsProps) => {
  const { t } = useTranslation();
  const hasPercentage = percentage !== null;

  const tooltip = hasPercentage ? (
    <Stack gap={3}>
      <Text fz={12} c="inherit">
        {t("effective-commission")}: {formatPercentage(percentage)}
      </Text>
      {source === "derived" && (
        <Text fz={12} c="inherit">
          {t("commission-derived-note")}
        </Text>
      )}
    </Stack>
  ) : (
    t("commission-unavailable")
  );

  return (
    <Group gap={4} wrap="nowrap">
      <Text fz={13} c={hasPercentage ? "dimmed" : "gray.6"}>
        {hasPercentage ? formatPercentage(percentage) : t("not-available-short")}
      </Text>
      <Tooltip
        events={{ hover: true, focus: true, touch: true }}
        label={tooltip}
        multiline
        maw={320}
        withArrow>
        <IconInfoCircle size={16} stroke={1.5} />
      </Tooltip>
    </Group>
  );
};
